import React, { useState } from 'react'
import {
  Form,
  Button,
  Container,
  ButtonGroup,
  ToggleButton
} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const SearchBox = () => {
  const [keyword, setKeyword] = useState('')
  const [radioValue, setRadioValue] = useState('1')

  const navigate = useNavigate()

  // const [alert, setAlert] = useState({
  //   show: false,
  //   message: '',
  //   variant: 'success'
  // })

  // function showAlert(message, variant = 'success', seconds = 2000) {
  //   setAlert({
  //     show: true,
  //     message,
  //     variant
  //   })

  //   setTimeout(() => {
  //     setAlert({
  //       show: false,
  //       message: '',
  //       variant: 'success'
  //     })
  //   }, seconds)
  // }

  const submitHandler = (e) => {
    e.preventDefault()
    if (keyword.trim()) {
      let word = keyword
      let radio = radioValue
      let wordradio = word + radio
      navigate(`/search/${wordradio}/*`)
    } else {
      setKeyword('')
      setRadioValue('1')
      navigate('/inventory')
    }
  }

  const radios = [
    { name: 'UPC', value: '1' },
    { name: 'Mfg', value: '2' },
    { name: 'Name', value: '3' }
  ]

  return (
    <Container className='search-shell inventory-search-shell'>
      <Form className='inventory-search-form' onSubmit={submitHandler}>
        <Form.Control
          type='text'
          name='q'
          onChange={(e) => setKeyword(e.target.value)}
          placeholder='Search by UPC, manufacturer, or item name'
          aria-label='Search inventory'
          className='search-input inventory-search-input'
        />
        <Button
          type='submit'
          variant='primary'
          className='search-action-btn inventory-search-button'
        >
          Search
        </Button>
        <div className='inventory-search-filters'>
          <span className='inventory-search-filter-label'>Match by</span>
          <ButtonGroup className='search-toggle-group' aria-label='Match by'>
            {radios.map((radio, idx) => (
              <ToggleButton
                key={idx}
                id={`radio-${idx}`}
                type='radio'
                variant='outline-secondary'
                size='sm'
                name='radio'
                value={radio.value}
                checked={radioValue === radio.value}
                onChange={(e) => setRadioValue(e.currentTarget.value)}
              >
                {radio.name}
              </ToggleButton>
            ))}
          </ButtonGroup>
        </div>
      </Form>
    </Container>
  )
}

export default SearchBox
